import { setCursor } from '../helpers';

import { Utils } from '../classes/Utils';
import { pricing } from '../../../schemas/pricing';
const util = new Utils();
export const handleLayerRestrictions = ({ state, auth, origcountry, county, wmslayercheck }) => {
  ['lr', 'planning', 'flood', 'transport', 'extended'].forEach(grp => {
    let list = '<ul class="section_pad">';
    if (grp === 'all' || grp === 'lr' || grp === 'extended') {
      pricing.groups[grp].layers.forEach((item, i) => {
        list = `${list}<li class="snapshot_item ${item.class || ''}" id="${`${item.layer}_ds` || `layer_${i}`}">${
          item.label
        }</li>`;
      });
    } else {
      pricing.groups[grp].layers.forEach((item, i) => {
        const checked = state.snapshotLayers.includes(item.layer) || state.snapshotGroups.includes(grp);
        const warning = item.warning ? `data-warning="${item.warning}"` : '';
        list = `${list}<li class="snapshot_item ${item.class || ''}" id="${
          `${item.layer}_ds` || `layer_${i}`
        }"><input ${warning} data-layer="${item.layer || ''}" data-group="${grp}" type='checkbox' ${
          checked ? 'checked' : ''
        } class='checkmark snapshot_layer' />${item.label}</li>`;
      });
    }
    list = `${list}</ul>`;
    $(`#${grp}_section`).html(list);
  });
  if ($('#notAffected').children().length > 0) {
    $('#notAffected')
      .children()
      .each((ix, o) => {
        const parent = $(o).data('parent');
        const el = $(o).detach();
        $(`#${parent}`).append(el);
        $(`#${parent}`).html(
          $(`#${parent}`)
            .children()
            .sort((a, b) => (a.outerText < b.outerText ? -1 : 1)),
        );
      });
  }
  $('.show').removeClass('show');
  if (state.coverage) {
    auth = state.coverage.restrict.auth;
    origcountry = state.coverage.restrict.origcountry;
    county = state.coverage.restrict.county;
    prow = state.coverage.restrict.prow;
    wmslayercheck = state.coverage.wmslayercheck;
  }
  if (typeof auth != 'undefined' && auth === 'City and County of the City of London') {
    $('.col').addClass('show');
  }
  if (typeof auth !== 'undefined' && auth === 'Stockport District (B)') {
    $('.stockport').addClass('show');
  }
  if (typeof auth !== 'undefined' && auth === 'West Dorset District') {
    $('.westdorset').addClass('show');
  }
  if (typeof origcountry !== 'undefined' && origcountry === 'England') {
    $('.england').removeClass('hidelayer');
    $('.wales').addClass('hidelayer');
    //    $('.England').addClass('show');
  }
  if (typeof origcountry !== 'undefined' && origcountry === 'Wales') {
    $('.wales').removeClass('hidelayer');
    $('.england').addClass('hidelayer');
    //$('.Wales').addClass('show');
  }
  if (typeof county !== 'undefined' && county === 'Cheshire East') {
    // $('.cheshire').removeClass('noshow');
    $('.cheshire').addClass('show');
  }
  if (typeof county !== 'undefined' && county === 'Cheshire West And Chester') {
    // $('.cheshire').removeClass('noshow');
    $('.cheshirewest').addClass('show');
  }
  if (typeof auth !== 'undefined' && auth === 'North Norfolk District') {
    $('.norfolk').addClass('show');
  }
  if (typeof county !== 'undefined' && county === 'Greater London Authority') {
    $('.gla').addClass('show');
  }
  if (typeof wmslayercheck != 'undefined') {
    for (var i = 0; i < wmslayercheck.length; i++) {
      let l, lds, ldsall;
      if (typeof util.WMSlayers[wmslayercheck[i]] === 'string') {
        l = '#' + util.WMSlayers[wmslayercheck[i]] + '-layer';
        lds = '#' + util.WMSlayers[wmslayercheck[i]] + '_ds';
        ldsall = '#' + util.WMSlayers[wmslayercheck[i]] + '_ds_all';
      } else if (typeof util.WMSlayers[wmslayercheck[i]] === 'object') {
        l = '#' + util.WMSlayers[wmslayercheck[i]][origcountry.toLowerCase()] + '-layer';
        lds = '#' + util.WMSlayers[wmslayercheck[i]][origcountry.toLowerCase()] + '_ds';
        ldsall = '#' + util.WMSlayers[wmslayercheck[i]][origcountry.toLowerCase()] + '_ds_all';
      }
      if (wmslayercheck[i] === 'ca_coalfield_consultation_area') {
        $('.coal').addClass('show');
      }
      if (wmslayercheck[i] === 'built_up_area') {
        state.restrictTitleNumbersLevel = 9;
      }
      if (l) {
        [l, lds, ldsall].forEach(o => {
          $(o).addClass('show');
        });
      }
    }
  }
  if (!prow) $('#prow-layer').addClass('noshow');
  else $('#prow-layer').addClass('show');
  $('.show input').removeAttr('disabled');
  $('.show').attr('title', '');
  $('.noshow input')
    .not('.show input')
    .each(function () {
      if ($(this).prop('checked')) $(this).click();
    });
  $('.noshow input').not('.show input').attr('disabled', 'disabled');
  $('.noshow').not('.show').attr('title', 'Not available at your current location');
  $('.data_overlays').each(function () {
    var ns = $(this).find('.noshow').not('.show').length;
    var t = $(this).find('li').length;
    if (ns === t) {
      $(this).css('color', '#aaaaaa');
      $(this).css('display', 'none');
    } else {
      $(this).css('color', '#ffffff');
      $(this).css('display', 'block');
    }
  });
  if ($('.noshow').not('.show').length) {
    let elements = $('.noshow').not('.show').detach();
    elements = elements.sort((a, b) => (a.outerText < b.outerText ? -1 : 1));
    $('#notAffected').append(elements);
  }
};
export function activateCheckboxes() {
  $('.data_overlays').each(function () {
    var ch = false;
    $(this).find('.fa-check').css('visibility', 'hidden');
    var ns = $(this).find('.layercb');
    $(ns).each(function () {
      if (this.checked) ch = true;
    });
    if (ch) {
      $(this).find('.fa-check').css('visibility', 'visible');
    } else {
      $(this).find('.lt-arrow').css('color', $(this).css('color'));
    }
    var t = $(this).find('li').length;
    if (ns === t) {
      $(this).css('color', '#aaaaaa');
    }
  });
}
export function showHideSidebar(map, state) {
  if ($('.sidebar').is(':visible')) {
    $('.sidebar').hide('slide', { direction: 'left' }, 100);
    $('.main').css('margin-left', '0px');
    $('#output').css('left', '0px');
    $('#showHideArrow').removeClass('fa-chevron-left');
    $('#showHideArrow').addClass('fa-chevron-right');
    //$('.poweredby').css('left', '5px');
    $('#toolbar').css('left', '10px');
    $('#home').css('left', '8px');
    //    $('#map, #watermark').css('left', '0px');
    state.sidebarWidth = 0;
  } else {
    $('.sidebar').show('slide', { direction: 'left' }, 100);
    $('.main').css('margin-left', '250px');
    $('#showHideArrow').removeClass('fa-chevron-right');
    $('#showHideArrow').addClass('fa-chevron-left');
    $('#output').css('left', '249px');
    $('#toolbar').css('left', '260px');
    $('#home').css('left', '258px');
    //    $('#map, #watermark').css('left', '250px');
    //$('.poweredby').css('left', '255px');
    state.sidebarWidth = 250;
  }
  map.updateSize();
}
export const createSavedCard = ({ attr, address }) => `<div data-lrtitle='${attr.title_no}' class='saved-poly'>
<img src='assets/img/bin.png' class='bin' onclick='removeSaved("${attr.title_no}")' />
<div class='label'>Title No.</div>
<div class='value'>${attr.title_no}</div>
<div class='label'>Address.</div>
<div class='value'>${address}</div>
</div>`;

export const addressForm = `<ul>${[
  { label: 'Organisation', input: 'organisation' },
  { label: 'Subpremise', input: 'subpremise' },
  { label: 'House number/name', input: 'name-number' },
  { label: 'Street', input: 'street' },
  { label: 'Town', input: 'town' },
  { label: 'County', input: 'county' },
  { label: 'Country', input: 'country' },
  { label: 'Postcode', input: 'postcode' },
]
  .map(
    ({ label, input }) => `<li>
    <div class="label"><label>${label}:</label></div>
    <div class="input"><input class="textbox input-${input}"></div>
  </li>`,
  )
  .join('')}</ul>`;
export const buildLayerList = (layers, callback) => {
  let layerProps = {};
  let layerlist = '';
  Object.keys(layers.layer_groups).forEach(key => {
    const lg = layers.layer_groups[key];
    let marknew = false;
    Object.keys(lg.layers).forEach(k2 => {
      if (lg.layers[k2].new) marknew = true;
    });
    layerlist = `${layerlist}<li class="data_overlays"><div class="do_title"><div class="do_title_label"><i class="fa fa-${
      lg.icon
    } iconpad" aria-hidden="true"></i>${lg.label} ${
      lg.new || marknew ? '<sup>NEW</sup>' : ''
    }</div><i class="fa fa-check" aria-hidden="true"></i>&nbsp;<i class="fa fa-angle-right lt-arrow" aria-hidden="true"></i></div>`;
    layerlist = `${layerlist}<ul class="data_layers" id=${key}>`;
    if (key === 'lr') {
      layerlist = `${layerlist}<li>
          <div class="layer-label">
              Land Registry Polygons
          </div>
          <input class="layercb lrcheck landregmaster" type="checkbox" data-opacity="0.5"
              data-query="no" data-layertype="overlay" data-server="2"
              data-layer="vw_landreg_titles_address_lookup" />
          <div class="sub-layers">
              <ul>
                  <li id="lrfh">
                      <div class="sub-label">Freehold</div><input data-opacity="0.5"
                          data-query="no" data-layertype="overlay" data-server="2"
                          data-layer="vw_landreg_titles_address_lookup"
                          class="lrcheck layercb sublayercb" type="checkbox"
                          data-filter="freehold" />
                  </li>
                  <li id="lrlh">
                      <div class="sub-label">Leasehold</div><input data-opacity="0.5"
                          data-query="no" data-layertype="overlay" data-server="2"
                          data-layer="vw_landreg_titles_address_lookup"
                          class="lrcheck layercb sublayercb" type="checkbox"
                          data-filter="leasehold" />
                  </li>
                  <li id="lro">
                      <div class="sub-label">Other</div><input data-opacity="0.5"
                          data-query="no" data-layertype="overlay" data-server="2"
                          data-layer="vw_landreg_titles_address_lookup"
                          class="lrcheck layercb sublayercb" type="checkbox"
                          data-filter="other" />
                  </li>
                  <li id="lrtn">
                      <div class="sub-label">Title Numbers</div><input data-opacity="1"
                          data-query="yes" data-layertype="overlay" data-server="2"
                          data-layer="vw_lu_landreg_titles_number" disabled="disabled"
                          id="title_numbers" class="lrcheck layercb sublayercb"
                          type="checkbox" />
                  </li>
              </ul>
      </li>
  </ul>
`;
    } else {
      Object.keys(lg.layers).forEach(k2 => {
        if (k2 === 'lineSearch') {
          layerlist = `${layerlist}<li id="lineSearch-layer" class="">
          <div class="layer-label">
          Utilities (LineSearchBUD) <sup>NEW</sup> <span class="orange" id="totalLineSearch"></span>
          </div>
          <input class="layercb" type="checkbox" data-opacity="0.5" data-query="no"
              data-layertype="overlay" data-layer="lineSearch" />
          <div class="sub-layers lineSearch-sub">
              <ul style="padding-left:0">
                  <li style="padding-left:0">
                      <div id="lineSearch_settings">
                          <div style="vertical-align: top;float:left"><button
                                  id="lineSearch_cross">Select polygon</button><div class='loader' style='float:right'></div></div>
                          <div style="vertical-align: top;">
                              <div class="buffer-lab"
                                  style="display:inline-block;font-size:10px;margin-right:10px;">
                                  Search buffer</div><input type="range" min="0" max="75"
                                  value="0" step="25" id="lineSearch-range">
                                  <div style="float:right" id="lineSearch-radius">0m</div>
                             </div>
                      </div>
                  </li>
              </ul>
          </div>
      </li>
`;
        } else if (k2 === 'planning_applications') {
          layerlist = `${layerlist}<li id="planning_authorities-layer" class="noshow">
          <div class="layer-label">
              Planning Applications <span class="orange" id="totalPlanning"></span>
          </div>
          <input class="layercb" type="checkbox" data-opacity="0.5" data-query="no"
              data-layertype="overlay" data-layer="planning" />
          <div class="sub-layers planning-sub">
              <ul style="padding-left:0">
                  <li style="padding-left:0">
                      <div id="planning_settings">
                          <div style="vertical-align: top;float:left"><button
                                  id="planning_cross">Select polygon</button></div>
                          <div style="vertical-align: top;">
                              <div class="buffer-lab"
                                  style="display:inline-block;font-size:10px;margin-right:10px;">
                                  Search buffer</div><input type="range" min="0" max="75"
                                  value="1" step="25" id="planning-range">
                          </div>
                          <div style="float:right" id="planning-radius">1m</div><a
                              href="#" id="csv-link">Download CSV</a>
                      </div>
                  </li>
              </ul>
          </div>
      </li>
`;
        } else {
          const layer = lg.layers[k2];
          if (k2.split(',').length > 1) {
            k2.split(',').forEach(l => {
              layerProps[l] = {
                layerID: layer.layer,
                style: layer.style,
                label: layer.label || '',
                props: layer.props || {},
              };
            });
          }
          layerProps[k2] = {
            layerID: layer.layer,
            style: layer.style,
            label: layer.label || '',
            props: layer.props || {},
          };

          if (layer.proxy_layer)
            if (layer.proxy_layer.split(',').length > 1) {
              layer.proxy_layer.split(',').forEach(l => {
                layerProps[l] = {
                  layerID: layer.layer,
                  style: layer.style,
                  label: layer.label || '',
                  props: layer.props || {},
                };
              });
            }
          layerProps[layer.proxy_layer] = {
            layerID: layer.layer,
            style: layer.style,
            label: layer.label || '',
            props: layer.props || {},
          };

          layerlist = `${layerlist}
          <li data-parent="${key}" id="${`${k2}-layer`}" class="${layer.coverage ? 'noshow' : ''}${
            layer.restrict
              ? ` ${layer.classes ? layer.classes : layer.restrict} ${!layer.classes ? 'hidelayer' : ''}`
              : ''
          } ${layer.classes ? layer.classes : ''}">
          <div class="layer-label">
          ${layer.uilabel || layer.label} ${layer.new ? '<sup>NEW</sup>' : ''}
          </div>
          <input ${
            layer.wfs
              ? `data-wfs="true" data-outputformat="${layer.outputFormat || ''}" data-typeName="${
                  layer.typeName
                }" data-geom="${layer.geom}"`
              : ''
          } ${layer.id ? `id='${layer.id}'` : ''} ${
            layer.proxy_layer ? `data-proxy="${layer.proxy_layer}"` : 'data-server="2"'
          } class="layercb ${layer.nomm ? 'nomm' : ''}" type="checkbox" data-single="${
            layer.singleTile || 'false'
          }" data-opacity="${layer.opacity || 0.5}" data-query="yes" data-layertype="overlay" data-layer="${
            layer.layer
          }" />
          </li>`;
        }
      });
      layerlist = `${layerlist}</ul></li>`;
    }
  });
  layerlist = `${layerlist}<li><hr style="width:93%; margin-left:5px" /></li><li class="data_overlays_special" style="color: rgb(255, 255, 255); cursor: default;"><div class="do_title" style="cursor: default;"><div class="do_title_label" style="cursor: default;"><i class="fa fa-exclamation-triangle iconpad" aria-hidden="true" style="cursor: default;"></i>Not Affected </div><i class="fa fa-check" aria-hidden="true" style="cursor: default;"></i>&nbsp;<i class="fa lt-arrow fa-angle-right" aria-hidden="true" style="cursor: default;"></i></div><ul class="data_layers" id="notAffected" style="cursor: default; display: none;"></ul></li>`;
  $('#layer-list>.nav').append(layerlist);
  callback(layerProps);
  0;
};
export const setArea = ({ feat, pa }) => {
  const area = feat.geometry.getArea().toFixed(2);
  const acres = (area * 0.000247105).toFixed(2);
  $('#output').html(`Area: ${area}m<sup>2</sup> (${acres}acres)`);
  if (!pa) setCursor({ type: 'pointer' });
};

export const populatePrimary = prop => {
  let numberOrName = '';
  let street = '';
  if (prop.street1 && prop.street2) {
    street = `${prop.street1}, ${prop.street2}`;
  } else if (prop.street1) {
    street = prop.street1;
  } else if (prop.street2) {
    street = prop.street2;
  }
  if (prop.name && prop.number) numberOrName = `${prop.name}, ${prop.number}`;
  else if (prop.name) numberOrName = prop.name;
  else if (prop.number) numberOrName = prop.number;
  if (prop.locality1) street += street ? ', ' + prop.locality1 : prop.locality1;
  if (prop.locality2) street += street ? ', ' + prop.locality2 : prop.locality2;
  prop.current_occupier = prop.current_occupier ? prop.current_occupier : '';
  prop.town = prop.town ? prop.town : '';
  prop.postcode = prop.postcode ? prop.postcode : '';
  $('.input-organisation').val(prop.current_occupier.titleCase());
  $('.input-premise').val();
  if (numberOrName) $('.input-name-number').val(numberOrName.toString().titleCase());
  if (street) $('.input-street').val(street.titleCase());
  if (prop.town) $('.input-town').val(prop.town.titleCase());
  $('.input-postcode').val(prop.postcode);
  $('.input-country').val(prop.country);
  $('.input-county').val(prop.county);
};
